import { default as dashboard } from './dashboard/routes'
import { default as auth } from './auth/routes'
import { default as website } from './website/routes'
import { default as configuracoes } from './configuracoes/routes'
import { default as policiacivil } from './policia-civil/routes'
import callcenter from './callcenter/routes'
import relatorios from './relatorios/routes'
import solicitacoesRemocao from './solicitacao-remocao/routes'

export default [
  ...auth,
  ...dashboard,
  ...website,
  ...configuracoes,
  ...callcenter,
  ...relatorios,
  ...policiacivil,
  ...solicitacoesRemocao
]



// WEBPACK FOOTER //
// ./src/app/routes.js